// extracted by mini-css-extract-plugin
export default {"link":"AnchorLink_link__6j8HK","link__text":"AnchorLink_link__text__Avkmf","link__active":"AnchorLink_link__active__aHsku","link__activeMob":"AnchorLink_link__activeMob__of7JS"};